import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

//css
import './css/style.css';

//components
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Estrutura from './pages/Estrutura';
import Selecao from './pages/Selecao';
import Empresas from './pages/Empresas';
import Lideres from './pages/Lideres';
import Noticia from './pages/Noticia';
import Noticias from './pages/Noticias';
import Videos from './pages/Videos';
import FAQs from './pages/FAQs';

function App() {
  return (
    <Router>
      <div className="page-container">
        <Navbar />

        <Switch>
          <Route exact path="/" component={Home} />
          {/* 
          <Route exact path={['/noticias', '/noticia']}>
            <Redirect to="/" />
          </Route> */}

          <Route exact path="/noticia/:id" component={Noticia} />

          <Route exact path="/estrutura-do-curso" component={Estrutura} />

          <Route exact path="/selecao-de-formandos" component={Selecao} />

          <Route exact path="/empresas-aderentes" component={Empresas} />

          <Route exact path="/testemunhos" component={Lideres} />

          <Route exact path="/noticias" component={Noticias} />

          <Route exact path="/videos" component={Videos} />

          <Route exact path="/faqs" component={FAQs} />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
